import { render, staticRenderFns } from "./surveyPop.vue?vue&type=template&id=7061e061&scoped=true"
import script from "./surveyPop.vue?vue&type=script&lang=js"
export * from "./surveyPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7061e061",
  null
  
)

export default component.exports